import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class MaritalStatus extends Enum {
  key!: string;
  value!: string;

  static COMMON_LAW_PARTNER: MaritalStatus = {
    key: 'common_law_partner',
    get value() {
      return Lang.t('contact.common-partner');
    }
  };

  static DIVORCED: MaritalStatus = {
    key: 'divorced',
    get value() {
      return Lang.t('contact.divorced');
    }
  };

  static MARRIED: MaritalStatus = {
    key: 'married',
    get value(): string {
      return Lang.t('contact.married');
    }
  };

  static SEPARATED: MaritalStatus = {
    key: 'separated',
    get value(): string {
      return Lang.t('contact.separated');
    }
  };

  static SINGLE: MaritalStatus = {
    key: 'single',
    get value(): string {
      return Lang.t('contact.single');
    }
  };

  static WIDOWED: MaritalStatus = {
    key: 'widowed',
    get value(): string {
      return Lang.t('contact.widowed');
    }
  };
}
